module.exports = __webpack_public_path__ + "static/Sam-Julien-a9371aed5dd154dbebcf0dd09b48320a.png";